module.exports = __webpack_public_path__ + "img/制御工学7_6.c91e23a1.png";